import React, { useContext } from "react";
import {
    AuthProvider as ROCPAuthProvider,
    AuthContext as ROCPAuthContext,
} from "react-oauth2-code-pkce";

const COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN?.trim();
const REDIRECT_URL = `${window.location.origin}/auth/callback`;
const CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID;
const CLIENT_SECRET = process.env.REACT_APP_COGNITO_CLIENT_SECRET;
const LOGOUT_URL = `${window.location.origin}/logged-out`;

const authConfig = {
    decodeToken: false,
    autoLogin: false,
    clientId: CLIENT_ID,
    authorizationEndpoint: `${COGNITO_DOMAIN}/oauth2/authorize`,
    tokenEndpoint: `${COGNITO_DOMAIN}/oauth2/token`,
    redirectUri: REDIRECT_URL,
    scope: "email openid profile",
    onRefreshTokenExpire: (event) =>
        window.confirm(
            "Session expired. Refresh page to continue using the site?",
        ) && event.login(),
    ...(CLIENT_SECRET && {
        extraTokenParameters: {
            client_secret: CLIENT_SECRET,
        },
    }),
};

export function useAuth() {
    const context = useContext(ROCPAuthContext);

    const logOut = React.useCallback(() => {
        // Trigger cross-tab logout sync event before clearing storage
        localStorage.setItem(
            "httrader_client_portal_logout",
            Date.now().toString(),
        );

        // Clear local storage and session storage
        localStorage.clear();
        sessionStorage.clear();

        // Clear cookies
        document.cookie.split(";").forEach((c) => {
            const eqPos = c.indexOf("=");
            const name = eqPos > -1 ? c.substring(0, eqPos) : c;
            document.cookie =
                name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
        });

        // Full SSO logout - clears Cognito session
        window.location.href = `${COGNITO_DOMAIN}/logout?client_id=${CLIENT_ID}&logout_uri=${encodeURIComponent(
            LOGOUT_URL,
        )}`;
    }, []);

    return { ...context, logOut };
}

export function AuthProvider({ children }) {
    return (
        <ROCPAuthProvider authConfig={authConfig}>{children}</ROCPAuthProvider>
    );
}
